const translations = {
  // Navbar
  nav_services: 'Servicios',
  nav_industries: 'Industrias',
  nav_pricing: 'Precios',
  nav_faq: 'FAQ',
  nav_testimonials: 'Testimonios',
  nav_contact: 'Contacto',
  nav_login: 'Iniciar Sesión',
  nav_register: 'Registrarse',
  nav_demo: 'Agenda tu Cita',
  theme_dark: 'Oscuro',
  theme_light: 'Claro',
  // Hero
  hero_badge: 'Ideas que se adaptan · Innovación que transforma',
  hero_headline_1: 'Gestiona Más.',
  hero_headline_2: 'Crece Sin Límites.',
  hero_sub: 'Sistemas de gestión, apps móviles, páginas web y software a la medida para negocios que quieren automatizarse, crecer y escalar.',
  hero_cta_demo: 'Agenda tu Cita Gratis',
  hero_cta_services: 'Ver Soluciones',
  hero_already_client: '¿Ya eres cliente? Iniciar sesión',
  stat_availability: 'Disponibilidad',
  stat_install: 'Tiempo de Instalación',
  stat_support: 'Soporte',
  // Benefits
  benefits_label: 'Beneficios Clave',
  benefits_title_1: 'Tres pilares del',
  benefits_title_2: 'éxito',
  benefit_auto_title: 'Automatización Total',
  benefit_auto_p1: 'Facturas y recibos automáticos',
  benefit_auto_p2: 'Reportes sin esfuerzo manual',
  benefit_auto_p3: 'Alertas inteligentes de stock',
  benefit_auto_p4: 'Cero errores de digitación',
  benefit_ctrl_title: 'Control Total',
  benefit_ctrl_p1: 'Panel de ventas en tiempo real',
  benefit_ctrl_p2: 'Gestión multi-sucursal',
  benefit_ctrl_p3: 'Rendimiento del personal',
  benefit_ctrl_p4: 'P&amp;G al instante',
  benefit_growth_title: 'Crecimiento Acelerado',
  benefit_growth_p1: 'Tendencias de ventas',
  benefit_growth_p2: 'Detección de fugas de ingresos',
  benefit_growth_p3: 'Retención de clientes',
  benefit_growth_p4: 'Escala sin cambiar de sistema',
  // WhyInnoflex
  why_label: '¿Por qué elegirnos?',
  why_title: 'El socio tecnológico que',
  why_title_accent: 'merece',
  why_title_mid: 'tu negocio',
  why_sub: 'ERP, POS, contabilidad y facturación electrónica en un solo sistema. Diseño y desarrollo de software especializado adaptado exactamente a la forma en que operas.',
  why_r1_title: 'Activo desde 48h',
  why_r1_desc: 'En marcha en dos días, no semanas.',
  why_r2_title: 'Seguro y Confiable',
  why_r2_desc: 'Cifrado empresarial. 99.9% uptime garantizado.',
  why_r3_title: 'Soporte Real',
  why_r3_desc: 'WhatsApp, teléfono o correo — cuando nos necesites.',
  why_r4_title: 'ROI Comprobado',
  why_r4_desc: '+8 horas semanales ahorradas. 90% menos errores.',
  why_r5_title: 'Personalizable',
  why_r5_desc: 'Se adapta a tu flujo. No al revés.',
  why_r6_title: 'Sin IT',
  why_r6_desc: 'Intuitivo desde el día uno. Nosotros manejamos lo técnico.',
  why_stat_errors: 'Menos errores',
  why_stat_hours: 'Ahorro/semana',
  why_stat_setup: 'Instalación',
  why_stat_support: 'Soporte',
  // Services
  services_label: 'Nuestros Servicios',
  services_title_1: 'Diseño, Desarrollo &',
  services_title_accent: 'Soluciones Inteligentes',
  services_sub: 'Cuatro pilares de servicio — sistemas de gestión, apps móviles, páginas web y consultoría tecnológica. Todo bajo un mismo equipo.',
  services_f1_title: 'Control Financiero',
  services_f1_i1: 'Ventas, gastos y P&G',
  services_f1_i2: 'Reportes en tiempo real',
  services_f2_title: 'Inventario Inteligente',
  services_f2_i1: 'Control de stock en vivo',
  services_f2_i2: 'Alertas automáticas de reposición',
  services_f3_title: 'Facturación DGII',
  services_f3_i1: 'e-CF certificado',
  services_f3_i2: 'Documentos y recibos automáticos',
  services_f4_title: 'Gestión Operativa',
  services_f4_i1: 'Cajas, empleados y turnos',
  services_f4_i2: 'Compras y proveedores',
  services_f5_title: 'Acceso Universal',
  services_f5_i1: 'Cualquier dispositivo',
  services_f5_i2: 'Funciona sin internet',
  services_f6_title: 'Suite Avanzada',
  services_f6_i1: 'Sistema de citas',
  services_f6_i2: 'Bot WhatsApp + Catálogo digital',
  services_badge_exclusive: 'EXCLUSIVO',
  services_custom_label: 'Desarrollo a la Medida',
  services_custom_title_1: 'No vendemos software.',
  services_custom_title_2: 'Creamos soluciones.',
  services_custom_sub: 'Tecnología que se adapta a tu forma de trabajar.',
  services_custom_i1: 'Sistema 100% adaptable',
  services_custom_i2: 'Personalización total',
  services_custom_i3: 'Escala contigo',
  services_custom_i4: 'Apps y plataformas web',
  services_whatsapp_cta: 'Habla con un asesor',
  // Services — 4 Pillars
  services_p1_title: 'Sistemas de Gestión',
  services_p1_sub: 'ERP, POS y contabilidad integrados — software completo para operar y automatizar tu negocio con total control',
  services_p1_f1: 'Facturación electrónica DGII certificada',
  services_p1_f2: 'Control de inventario en tiempo real',
  services_p1_f3: 'Cajas (POS), empleados y reportes avanzados',
  services_p1_f4: 'Multi-sucursal · Funciona sin internet',
  services_p1_for: 'Ideal para:',
  services_p1_tag1: 'Restaurantes',
  services_p1_tag2: 'Supermercados',
  services_p1_tag3: 'Ferreterías',
  services_p1_tag4: 'Dealers / ERP',
  services_p2_title: 'Apps Móviles',
  services_p2_sub: 'Aplicaciones iOS y Android diseñadas desde cero para tu negocio',
  services_p2_f1: 'Diseño UX/UI moderno y personalizado',
  services_p2_f2: 'Integración con APIs y sistemas existentes',
  services_p2_f3: 'Publicación en App Store & Google Play',
  services_p2_f4: 'Backend escalable, seguro y en la nube',
  services_p2_for: 'Tecnologías:',
  services_p2_tag1: 'iOS & Android',
  services_p2_tag2: 'React Native',
  services_p2_tag3: 'Flutter',
  services_p3_title: 'Páginas Web',
  services_p3_sub: 'Presencia digital profesional que convierte visitas en clientes reales',
  services_p3_f1: 'Diseño responsivo y moderno a la medida',
  services_p3_f2: 'Landing pages, corporativos y e-commerce',
  services_p3_f3: 'SEO técnico optimizado desde el inicio',
  services_p3_f4: 'Velocidad, hosting y dominio gestionados',
  services_p3_for: 'Tipos:',
  services_p3_tag1: 'Landing Pages',
  services_p3_tag2: 'E-commerce',
  services_p3_tag3: 'Portafolios',
  services_p4_title: 'Consultoría',
  services_p4_sub: 'Estrategia tecnológica para digitalizar y escalar tu negocio',
  services_p4_f1: 'Diagnóstico completo de procesos y sistemas',
  services_p4_f2: 'Plan de digitalización personalizado',
  services_p4_f3: 'Selección e integración de herramientas',
  services_p4_f4: 'Acompañamiento y seguimiento post-proyecto',
  services_p4_for: 'Para:',
  services_p4_tag1: 'Startups',
  services_p4_tag2: 'PYMEs',
  services_p4_tag3: 'Empresas',
  services_cta_heading: 'Cada solución, diseñada exactamente para ti',
  services_cta_desc: 'No vendemos plantillas. Entendemos tu negocio, identificamos lo que necesitas y construimos la solución perfecta — sin complicaciones.',
  services_cta_ask: 'Hablar con un asesor',
  services_cta_book: 'Agenda tu Cita Gratis',
  // Industries
  industries_label: 'La Familia InnoFlex',
  industries_title_1: 'Diseñado para tu',
  industries_title_accent: 'tipo de negocio',
  industries_sub: 'InnoFlex no es solo un POS. Es un ERP modular con una edición especializada para cada tipo de negocio.',
  industries_see: 'Ver solución',
  industries_all: 'Estas son solo algunas: InnoFlex se adapta a cualquier industria, entre muchas otras.',
  industries_rec: 'Plan recomendado',
  fam_1_industry: 'Supermercados',
  fam_1_plan: 'Pro o Premium',
  fam_1_desc: 'Inventario complejo, códigos de barra, venta por peso, precios por cliente, compras, múltiples almacenes, alertas y vencimientos.',
  fam_2_industry: 'Restaurantes, coffeeshops y food trucks',
  fam_2_plan: 'Pro o Premium',
  fam_2_desc: 'Mesas, comandas, cocina, recetas, productos terminados, combos, caja por turno y pedidos.',
  fam_3_industry: 'Odontología',
  fam_3_plan: 'Premium o Personalizado',
  fam_3_desc: 'Citas, odontograma, historia clínica, tratamientos por pieza, presupuestos, cobros, inventario e insumos.',
  fam_13_industry: 'Clínicas y consultorios médicos',
  fam_13_plan: 'Premium o Personalizado',
  fam_13_desc: 'Citas, expedientes médicos, historia clínica, consultas, recetas, cobros, inventario y ARS/seguros.',
  fam_4_industry: 'Distribución y rutas',
  fam_4_plan: 'Premium o Personalizado',
  fam_4_desc: 'Rutas inteligentes, vendedores, sectores, metas, GPS, inventario por vehículo y WhatsApp a clientes.',
  fam_5_industry: 'Ferreterías',
  fam_5_plan: 'Pro o Premium',
  fam_5_desc: 'Inventario complejo, códigos de barra, venta por unidad o peso, compras, múltiples almacenes, alertas y vencimientos.',
  fam_6_industry: 'Rent a Car',
  fam_6_plan: 'Premium o Personalizado',
  fam_6_desc: 'Flota, reservas, contratos, depósitos, inspección, daños, multas, fotos y firma digital.',
  fam_7_industry: 'Condominios',
  fam_7_plan: 'Premium o Personalizado',
  fam_7_desc: 'Cuotas recurrentes, moras, residentes, contratos, estados de cuenta, incidencias, documentos y reportes.',
  fam_8_industry: 'Venta de repuestos',
  fam_8_plan: 'Business o Pro',
  fam_8_desc: 'Catálogo por marca y modelo, inventario, facturación, compras, clientes, descuentos y equivalencias de piezas.',
  fam_9_industry: 'Agencias de préstamos',
  fam_9_plan: 'Premium o Personalizado',
  fam_9_desc: 'Clientes, contratos, financiamientos, cuotas, mora, documentos, reportes y flujo de caja.',
  fam_10_industry: 'Gimnasios, clubes y academias',
  fam_10_plan: 'Business o Pro',
  fam_10_desc: 'Membresías y suscripciones, cobros recurrentes, control de acceso, clases, entrenadores y renovaciones.',
  fam_11_industry: 'Talleres y servicios técnicos',
  fam_11_plan: 'Business o Pro',
  fam_11_desc: 'Órdenes de servicio, reparaciones, garantías, repuestos, presupuestos, historial por cliente y cobros.',
  fam_12_industry: 'Tiendas en general (ropa, zapatos, regalos)',
  fam_12_plan: 'Business o Pro',
  fam_12_desc: 'Inventario por tallas y variantes, facturación, compras, clientes, descuentos, alertas y vencimientos.',
  ind_1_title: 'Restaurantes',
  ind_1_desc: 'Mesas, pedidos y facturación en un solo lugar.',
  ind_1_stat: '↑ 40% eficiencia',
  ind_2_title: 'Supermercados',
  ind_2_desc: 'Cobro rápido, inventario real y reportes diarios.',
  ind_2_stat: '↑ 3x velocidad',
  ind_3_title: 'Ferreterías',
  ind_3_desc: 'Miles de productos, facturas al instante.',
  ind_3_stat: '↓ 90% errores',
  ind_4_title: 'Minimarkets',
  ind_4_desc: 'Rápido de implementar, fácil de usar.',
  ind_4_stat: 'Instalación desde 48h',
  ind_5_title: 'Dealers',
  ind_5_desc: 'ERP, contabilidad, POS y control total para tu dealership.',
  ind_5_stat: '↑ 60% control',
  ind_6_title: 'Agencias de Préstamos',
  ind_6_desc: 'Clientes, pagos y cuotas con total precisión.',
  ind_6_stat: '24/7 acceso',
  // Testimonials
  test_label: 'Casos de Éxito',
  test_title_1: 'Negocios que',
  test_title_accent: 'dieron el salto',
  test_sub: 'Empresas reales de distintos sectores que ya operan con InnoFlex todos los días — y siguen creciendo.',
  cases_count: 'negocios activos',
  cases_tab_all: 'Todos',
  cases_ind_dealers: 'Dealers',
  cases_ind_restaurants: 'Restaurantes',
  cases_ind_distribution: 'Distribución',
  cases_ind_hardware: 'Ferreterías',
  cases_ind_tech: 'Tecnología',
  cases_ind_retail: 'Retail / Comercios',
  cases_ind_food: 'Alimentos',
  cases_join_title: '¿Tu negocio será el próximo?',
  cases_join_cta: 'Quiero dar el salto',
  test_1_role: 'Propietario',
  test_1_company: 'Liwama Autoimport',
  test_1_industry: 'Automotriz',
  test_1_quote: 'Antes manejaba todo con papeles y cuadernos. Desde que implementamos InnoFlex tengo el control total de las ventas, inventario de piezas y cuentas de clientes en un solo lugar. La facturación electrónica me facilita todo con la DGII.',
  test_2_role: 'Dueña',
  test_2_company: "Liesca's Parties",
  test_2_industry: 'Eventos',
  test_2_quote: 'El sistema de citas y el bot de WhatsApp nos cambiaron la operación por completo. Antes los clientes llamaban y había confusión con los eventos. Ahora todo se agenda automáticamente, nunca hay doble reserva y las ventas subieron porque atendemos más clientes organizados.',
  test_3_role: 'Dueño',
  test_3_company: 'Minimarket Doña Negra',
  test_3_industry: 'Minimarket',
  test_3_quote: 'Tenía todo anotado en papel y siempre perdía el control del inventario. Desde que uso InnoFlex sé exactamente lo que entra y lo que sale. Las alertas de stock me han salvado de quedarme sin productos varias veces. Lo recomiendo a cualquier colmadero.',
  test_4_role: 'Dueño',
  test_4_company: 'Spartech Computadoras',
  test_4_industry: 'Tecnología',
  test_4_quote: 'Vender equipos, accesorios y dar servicio técnico al mismo tiempo era complicado de manejar. InnoFlex me permite llevar el control de reparaciones, garantías, inventario y facturar electrónicamente sin complicaciones. Le dio un nivel profesional a mi negocio.',
  // Pricing
  pricing_label: 'Precios',
  pricing_title_1: 'Elige el plan que',
  pricing_title_accent: 'se adapta a ti',
  pricing_sub: 'Sin sorpresas ni letra pequeña. Cada plan incluye implementación, capacitación y las herramientas exactas que tu negocio necesita.',
  pricing_billing_note: 'Planes exclusivos para el Sistema de Facturación',
  pricing_other_services: 'Apps, páginas web o consultoría → precio según el proyecto',
  pricing_monthly: 'Mensual',
  pricing_annual: 'Anual',
  pricing_cards: 'Planes',
  pricing_compare: 'Comparar',
  pricing_note: 'Todos los planes incluyen implementación, configuración y capacitación inicial',
  pricing_impl: 'implementación — único pago',
  pricing_save: 'Ahorras',
  pricing_usd_month: 'USD/mes',
  pricing_usd_year: 'USD/año',
  pricing_year: 'año',
  pricing_view_more: 'Ver más',
  pricing_view_less: 'Ocultar detalles',
  pricing_whats_included: '¿Qué incluye?',
  pricing_compare_show: 'Comparar planes',
  pricing_compare_hide: 'Ocultar comparación',
  pricing_badge_popular: 'Más Popular',
  pricing_badge_max: 'Máximo Poder',
  plan_starter_tagline: 'Para negocios que necesitan facturar, vender y controlar lo básico sin complicarse.',
  plan_business_tagline: 'Para negocios que ya necesitan compras, cuentas, reportes y mejor control operativo.',
  plan_pro_tagline: 'Para empresas que necesitan inventario avanzado, contabilidad, alertas y automatización.',
  plan_premium_tagline: 'Para operaciones multi-área o multi-sucursal que necesitan control total, soporte prioritario y módulos especializados.',
  plan_starter_cta: 'Elegir Starter',
  plan_business_cta: 'Elegir Business',
  plan_pro_cta: 'Elegir Pro',
  plan_premium_cta: 'Elegir Premium',
  compare_feature_col: 'Funcionalidad',
  // ── Plan features (incluye / no incluye) ──────────────────────
  pf_includes_starter: 'Todo lo de Starter',
  pf_includes_business: 'Todo lo de Business',
  pf_includes_pro: 'Todo lo de Pro',
  // Starter
  pf_billing_pos: 'Facturación / POS básico',
  pf_clients_products: 'Clientes y productos',
  pf_inventory_basic: 'Inventario básico',
  pf_dashboard_basic: 'Dashboard básico de ventas',
  pf_reports_simple: 'Reportes simples',
  pf_support_standard: 'Soporte con respuesta en 24–48 h vía correo o canal dedicado de tu empresa',
  // Business
  pf_purchases_suppliers: 'Compras y proveedores (básico)',
  pf_ar_ap_basic: 'Cuentas por cobrar / pagar (básico)',
  pf_low_stock_alerts: 'Alertas de stock bajo',
  pf_discounts_simple: 'Descuentos simples',
  pf_price_lists_2: 'Hasta 2 listas de precios',
  pf_bulk_upload_basic: 'Carga masiva básica',
  pf_support_whatsapp: 'Soporte con respuesta en 12–24 h desde la solicitud, por el canal dedicado de tu empresa',
  // Pro
  pf_inventory_advanced: 'Inventario avanzado',
  pf_price_lists_advanced: 'Listas de precios avanzadas',
  pf_discounts_per_client: 'Descuentos por cliente',
  pf_combos_coupons: 'Combos y cupones',
  pf_accounting_operational: 'Contabilidad operativa',
  pf_smart_alerts: 'Alertas inteligentes',
  pf_reports_management: 'Reportes gerenciales',
  pf_roles_permissions: 'Roles y permisos avanzados',
  pf_offline_operational: 'Modo offline operativo',
  pf_support_priority_pro: 'Soporte prioritario con respuesta ≤ 8 h por el canal dedicado, más 24/7 para emergencias',
  // Premium
  pf_multistore: 'Multi-sucursal',
  pf_dashboards_advanced: 'Dashboards avanzados',
  pf_bulk_messaging: 'Mensajes masivos segmentados',
  pf_ai_included_limited: 'Chatbot / WhatsApp / IA básica (con límite)',
  pf_user_audit: 'Auditoría de usuarios',
  pf_support_critical: 'Línea directa de soporte por el canal dedicado, con atención 24/7 para emergencias',
  // Personalizado
  pf_scaled_resources: 'Usuarios, cajas y sucursales según alcance',
  pf_industry_modules: 'Módulos especializados por industria',
  pf_integrations_custom: 'Integraciones',
  pf_api: 'API e integraciones',
  pf_ai_by_usage: 'IA / WhatsApp según consumo',
  pf_sla_agreed: 'SLA acordado',
  pf_dedicated_channel: 'Canal dedicado',
  pf_account_manager: 'Account manager',
  pf_training_recurring: 'Capacitación recurrente',
  pf_custom_dev: 'Desarrollo personalizado (cotizado aparte)',
  // Exclusiones (para las "X" en las tarjetas / comparativa)
  pf_offline: 'Modo offline',
  pf_ai_chatbot: 'IA / Chatbot',
  pf_ai_advanced: 'IA avanzada',
  pf_routes_gps: 'Rutas / GPS avanzado',
  pf_sla_dedicated: 'SLA dedicado',
  pf_integrations_complex: 'Integraciones complejas',
  // FAQ
  faq_label: 'Preguntas Frecuentes',
  faq_title_1: 'Resolvemos tus',
  faq_title_2: 'dudas',
  faq_sub: 'Todo lo que necesitas saber antes de dar el paso. Si tienes alguna pregunta que no está aquí, escríbenos directamente.',
  faq_cat_sub: 'Encuentra la respuesta que necesitas sobre InnoFlex.',
  faq_questions: 'preguntas',
  faq_bottom_title: '¿Tienes otra pregunta?',
  faq_bottom_sub: 'Nuestro equipo responde en minutos.',
  faq_bottom_cta: 'Contáctanos',
  // FAQ Categories
  faq_cat_sistema: 'El Sistema',
  faq_cat_implementacion: 'Implementación',
  faq_cat_facturacion: 'Facturación',
  faq_cat_desarrollo: 'Desarrollo',
  faq_cat_planes: 'Planes & Precios',
  faq_cat_digital_dev: 'Apps & Webs',
  faq_cat_republicafel: 'RepublicaFEL',
  // FAQ - El Sistema
  faq_s1_q: '¿Qué incluye InnoFlex?',
  faq_s1_a: 'Facturación electrónica, control de inventario, gestión de cajas y empleados, reportes financieros en tiempo real, acceso desde celular, sistema de citas, bot de WhatsApp y ventas por catálogo digital — todo en una sola plataforma.',
  faq_s2_q: '¿Funciona sin internet?',
  faq_s2_a: 'Sí. InnoFlex opera en modo offline. Puedes seguir vendiendo y facturando sin conexión. Los datos se sincronizan automáticamente cuando vuelve la señal.',
  faq_s3_q: '¿Desde qué dispositivos puedo acceder?',
  faq_s3_a: 'Desde cualquier dispositivo: celular, tablet, laptop o escritorio. Solo necesitas el navegador o la app — sin instalaciones complejas.',
  // FAQ - Implementación
  faq_i1_q: '¿Cuánto tarda la implementación?',
  faq_i1_a: 'Desde 48h tu sistema está activo y tu equipo capacitado (el tiempo depende del tipo de empresa). Nosotros manejamos toda la configuración técnica — tú solo te enfocas en tu negocio.',
  faq_i2_q: '¿Trabajan solo en República Dominicana?',
  faq_i2_a: 'Nuestra base principal está en RD, pero trabajamos con negocios en toda Latinoamérica de forma remota sin ningún problema.',
  // FAQ - Facturación
  faq_f1_q: '¿Están certificados para facturación electrónica?',
  faq_f1_a: 'Sí. Contamos con proveedor certificado de facturación electrónica, cumpliendo todas las normativas fiscales de la DGII sin complicaciones adicionales.',
  faq_f2_q: '¿Qué documentos fiscales genera el sistema?',
  faq_f2_a: 'e-CF (Comprobante Fiscal Electrónico), notas de crédito y débito, recibos de pago y todos los documentos requeridos por la DGII — generados automáticamente con cada transacción.',
  faq_f3_q: '¿Qué incluye la Certificación e-CF con RepublicaFEL?',
  faq_f3_a: 'La Certificación e-CF via InnoFlex cuesta $300 (pago único). Incluye la activación del portal RepublicaFEL, configuración completa de tus e-CF ante la DGII y soporte de activación — $150 menos que contratar directamente con RepublicaFEL ($450). Si llevas el Paquete Completo, la certificación baja a $250 dentro del bundle de $450 total.',
  faq_f4_q: '¿Qué es el Portal RepublicaFEL y para qué sirve?',
  faq_f4_a: 'El Portal RepublicaFEL es la plataforma web de nuestro partner oficial de facturación electrónica. Desde ese portal puedes consultar todos tus e-CF emitidos, gestionar tus NCF, ver el historial de comprobantes fiscales y hacer seguimiento de transacciones directamente ante la DGII. Es el complemento perfecto para un ERP o sistema de gestión como InnoFlex.',
  faq_f5_q: '¿La facturación electrónica e-CF está incluida en el plan?',
  faq_f5_a: 'La facturación electrónica e-CF, la certificación, la firma digital y el proveedor/partner fiscal se contratan como servicio adicional y pueden tener costos aparte según tu caso. Tu mensualidad cubre el sistema ERP; el e-CF lo activas cuando lo necesites desde la sección de precios o contactándonos por WhatsApp.',
  faq_f6_q: '¿Cómo contrato el sistema de facturación e-CF?',
  faq_f6_a: 'El sistema e-CF se contrata como un add-on independiente de tu plan mensual. El costo es $300 (pago único) e incluye: activación del portal RepublicaFEL, configuración completa ante la DGII y soporte de activación. Si lo combinas con la implementación (Paquete Completo), el precio total baja a $450 y ahorras $200 vs. contratar todo por separado. Solo contáctanos por WhatsApp para iniciar el proceso.',
  // FAQ - Desarrollo
  faq_d1_q: '¿También hacen desarrollo de software a medida?',
  faq_d1_a: 'Por supuesto. InnoFlex es una empresa completa de diseño y desarrollo de software. Creamos apps móviles, sistemas internos, plataformas web y más — todo hecho a la medida exacta de tu negocio.',
  faq_d2_q: '¿Y si necesito más funciones?',
  faq_d2_a: 'InnoFlex crece contigo. Puedes agregar módulos, sucursales o funciones personalizadas en cualquier momento, sin cambiar de plataforma.',
  // FAQ - Apps & Webs
  faq_dd1_q: '¿Cuánto tarda desarrollar una app móvil o página web?',
  faq_dd1_a: 'Depende del alcance. Una landing o sitio corporativo puede estar listo en 1–2 semanas; una app móvil completa toma entre 6 y 16 semanas según las funciones. Siempre entregamos un cronograma detallado antes de empezar.',
  faq_dd2_q: '¿Qué tecnologías usan para apps y páginas web?',
  faq_dd2_a: 'Para apps móviles usamos React Native y Flutter (nativas iOS y Android). Para sitios web, React, Next.js y stacks modernos con SEO técnico incluido. En el backend, Node.js, bases de datos en la nube y APIs REST o GraphQL según se necesite.',
  faq_dd3_q: '¿El proyecto incluye diseño UI/UX?',
  faq_dd3_a: 'Sí. Cada app o web incluye diseño de interfaz y experiencia de usuario profesional: prototipos, identidad visual y flujos pensados para convertir visitantes en clientes.',
  faq_dd4_q: '¿Puedo pedir cambios o nuevas funciones después del lanzamiento?',
  faq_dd4_a: 'Sí. Ofrecemos contratos de mantenimiento y desarrollo continuo para todos los proyectos, y también puedes contratar horas de modificación por demanda. Tu producto crece junto a tu negocio.',
  faq_dd5_q: '¿Incluye hosting, dominio y publicación en las tiendas?',
  faq_dd5_a: 'Sí. Nos encargamos del hosting, la configuración del dominio y el despliegue en servidores en la nube. Para apps móviles gestionamos toda la publicación en App Store (Apple) y Google Play, incluyendo los pasos de revisión y aprobación.',
  // FAQ - RepublicaFEL
  faq_rfel1_q: '¿Qué es RepublicaFEL?',
  faq_rfel1_a: 'RepublicaFEL es el partner oficial de InnoFlex para facturación electrónica en República Dominicana. Es un proveedor certificado por la DGII que emite e-CF (Comprobantes Fiscales Electrónicos), notas de crédito, notas de débito y todos los documentos fiscales exigidos por ley.',
  faq_rfel2_q: '¿Necesito una cuenta separada de RepublicaFEL?',
  faq_rfel2_a: 'No tienes que gestionarla por tu cuenta. Al contratar la Certificación e-CF a través de InnoFlex ($300, o $250 en el Paquete Completo), activamos tu portal RepublicaFEL, lo configuramos ante la DGII y lo conectamos directo con tu sistema InnoFlex — todo incluido.',
  faq_rfel3_q: '¿Cómo funciona la integración InnoFlex + RepublicaFEL?',
  faq_rfel3_a: 'La integración es nativa y transparente. Cada vez que registras una venta en InnoFlex, el e-CF se genera automáticamente y se envía a la DGII a través del portal RepublicaFEL. No necesitas cambiar de sistema — todo ocurre dentro de InnoFlex en tiempo real.',
  faq_rfel4_q: '¿Qué puedo hacer en el Portal RepublicaFEL?',
  faq_rfel4_a: 'Desde el portal RepublicaFEL puedes consultar todos tus e-CF emitidos, gestionar tus NCF, ver el historial de comprobantes fiscales y hacer seguimiento de transacciones directamente ante la DGII. Es tu panel de control fiscal oficial, accesible en cualquier momento.',
  faq_rfel5_q: '¿Cuánto ahorro certificando vía InnoFlex vs. directo?',
  faq_rfel5_a: 'Ir directo con RepublicaFEL cuesta $450. A través de InnoFlex la certificación es $300 (ahorras $150). Con el Paquete Completo (implementación + e-CF + portal), el e-CF baja a $250 dentro del total de $450 — ahorrando $200 vs. comprar todo por separado ($650).',
  faq_rfel_q: '¿Tienes otra pregunta?',
  faq_rfel_a: 'Nuestro equipo responde en minutos.',
  faq_rfel6_q: '¿Cuánto tiempo toma activar la facturación e-CF?',
  faq_rfel6_a: 'Una vez contratado el add-on e-CF, la activación toma entre 3 y 5 días hábiles. En ese tiempo gestionamos toda la certificación ante la DGII, configuramos tu portal RepublicaFEL y lo conectamos con tu sistema InnoFlex. Tú solo esperas y en cuanto esté listo te notificamos por WhatsApp.',
  faq_rfel7_q: '¿Puedo contratar e-CF después de activar mi plan mensual?',
  faq_rfel7_a: 'Sí, en cualquier momento. El add-on e-CF es completamente independiente del plan mensual y se puede contratar en cualquier etapa — al inicio, meses después o cuando lo necesites. Solo escríbenos por WhatsApp y arrancamos el proceso de certificación sin afectar tu servicio actual.',
  // FAQ - Planes, add-ons e integraciones
  faq_pl1_q: '¿Qué planes ofrece InnoFlex y en qué se diferencian?',
  faq_pl1_a: 'Ofrecemos 5 planes: Starter ($29.99/mes), Business ($59.99), Pro ($99.99), Premium ($149.99) y Personalizado (bajo cotización). A medida que subes de plan aumentan los usuarios, cajas y sucursales incluidos, y se habilitan funciones como inventario avanzado, contabilidad operativa, multi-sucursal, mensajes masivos e IA.',
  faq_pl2_q: '¿La mensualidad incluye actualizaciones y soporte?',
  faq_pl2_a: 'Sí. Cada plan incluye el sistema completo, actualizaciones automáticas y soporte según tu plan, sin costos ocultos. La implementación es un pago único aparte.',
  faq_pl3_q: '¿Puedo cambiar de plan o agregar módulos más adelante?',
  faq_pl3_a: 'En cualquier momento. Puedes subir de plan o activar servicios adicionales (usuarios, cajas, sucursales o módulos por industria) según crezca tu negocio, sin cambiar de plataforma ni perder tu información.',
  faq_pl4_q: '¿Qué son los servicios adicionales o add-ons?',
  faq_pl4_a: 'Son complementos que activas solo si los necesitas: usuarios o cajas extra, sucursales adicionales, módulos por industria (restaurante, distribución, rent car, condominios, salud, construcción), mensajes de WhatsApp, chatbot con IA, API/integraciones, migración de datos y capacitación adicional.',
  faq_pl5_q: '¿Tienen integraciones de WhatsApp, IA o API?',
  faq_pl5_a: 'Sí. Ofrecemos mensajes y campañas por WhatsApp, chatbot con IA y una API para integraciones externas, todos como add-ons. Los consumos variables de IA, WhatsApp, SMS o servicios externos se cotizan por separado según el uso.',
  faq_pl6_q: '¿Qué nivel de soporte incluye cada plan?',
  faq_pl6_a: 'El soporte crece con tu plan: desde respuesta en 24–48 h por correo y canal dedicado (Starter), pasando por soporte prioritario con atención 24/7 en emergencias (Pro y Premium), hasta línea directa (Premium) y SLA acordado con account manager (Personalizado). Todos los planes cuentan con un canal de soporte creado para tu empresa.',
  faq_pl7_q: '¿Puedo probar el sistema antes de pagar?',
  faq_pl7_a: 'Sí. Ofrecemos una demo personalizada gratis, sin compromiso ni tarjeta de crédito. Agenda directamente en el calendario y en 1 hora te mostramos todo el sistema aplicado a tu negocio.',
  // FinalCTA
  cta_title_1: 'Tu próximo gran paso',
  cta_title_2: 'empieza con una cita',
  cta_sub: 'En 1 hora hablamos sobre lo que tu negocio necesita. Sin compromiso, sin letra pequeña.',
  cta_contact: 'Contáctanos',
  cta_calendar: 'Agenda tu Cita Gratis',
  cta_footer: 'Sin tarjeta de crédito · Instalación desde 48h',
  // Contact
  contact_label: 'Contáctanos',
  contact_title_1: 'Estamos aquí',
  contact_title_2: 'para ayudarte',
  contact_sub: 'Por WhatsApp, correo o formulario — estamos disponibles para resolver tus dudas y ayudarte a dar el siguiente paso.',
  contact_whatsapp_sub: 'Respuesta inmediata',
  contact_email_title: 'Correo Electrónico',
  contact_address_title: 'Dirección',
  contact_form_title: 'Envíanos un Mensaje',
  contact_form_name: 'Nombre completo',
  contact_form_phone: 'Teléfono',
  contact_form_email: 'Correo electrónico',
  contact_form_type: 'Tipo de negocio',
  contact_form_msg: 'Mensaje',
  contact_form_send: 'Enviar Mensaje',
  contact_form_sending: 'Enviando...',
  contact_success_title: '¡Mensaje recibido!',
  contact_success_sub: 'Te responderemos muy pronto. O escríbenos por WhatsApp para una respuesta aún más rápida.',
  contact_error: 'Algo salió mal. Intenta de nuevo o escríbenos por WhatsApp.',
  contact_select_placeholder: 'Selecciona tu industria...',
  // Plan Form Modal
  plan_form_selected: 'Plan seleccionado',
  plan_form_title: '¡Genial! Cuéntanos sobre tu negocio',
  plan_form_sub: 'Rellena el formulario y un asesor te contactará muy pronto para activar tu plan.',
  plan_form_name: 'Nombre completo',
  plan_form_name_placeholder: 'Tu nombre completo',
  plan_form_phone: 'Teléfono',
  plan_form_phone_placeholder: '+1 (809) 000-0000',
  plan_form_email: 'Correo electrónico',
  plan_form_email_placeholder: 'tu@correo.com',
  plan_form_business: 'Nombre del negocio',
  plan_form_business_placeholder: 'Ej. Colmado El Rey',
  plan_form_type: 'Tipo de negocio',
  plan_form_implementation: 'Implementación que necesitas',
  plan_form_impl_standard: 'Implementación Estándar — $200',
  plan_form_impl_full_bundle: 'Paquete Completo con e-CF — $450 (ahorras $200)',
  plan_form_impl_fel_only: 'Solo Certificación e-CF — $300',
  plan_form_msg: 'Mensaje adicional (opcional)',
  plan_form_msg_placeholder: '¿Tienes alguna pregunta o detalle especial sobre tu negocio?',
  plan_form_send: 'Enviar Solicitud',
  plan_form_sending: 'Enviando...',
  plan_form_success: '¡Solicitud enviada con éxito!',
  plan_form_success_sub: 'Un asesor de InnoFlex te contactará en menos de 24 horas para coordinar la activación de tu plan.',
  plan_form_error: 'Algo salió mal. Intenta de nuevo o escríbenos por WhatsApp.',
  plan_form_close: 'Cerrar',
  plan_form_ind_restaurant: 'Restaurante / Food & Beverage',
  plan_form_ind_supermarket: 'Supermercado / Colmado',
  plan_form_ind_hardware: 'Ferretería',
  plan_form_ind_minimarket: 'Minimarket / Colmado',
  plan_form_ind_distributor: 'Distribuidora / Dealer',
  plan_form_ind_loan: 'Agencia de Préstamos',
  plan_form_ind_events: 'Eventos / Entretenimiento',
  plan_form_ind_tech: 'Tecnología',
  plan_form_ind_other: 'Otro',
  // Navbar tagline
  nav_tagline: 'Ideas que se adaptan · Innovación que transforma',
  // BookDemo
  book_label: 'Agenda tu Cita',
  book_title_1: 'Reserva tu sesión',
  book_title_2: 'gratis',
  book_sub: 'Elige el tipo de servicio que necesitas y el horario que mejor te funcione. Un especialista estará contigo.',
  book_h1_text: 'Demo del Sistema',
  book_h1_sub: 'Ve el software en acción',
  book_h2_text: 'Consultoría',
  book_h2_sub: 'Asesoría tecnológica',
  book_h3_text: 'Proyecto Nuevo',
  book_h3_sub: 'Desarrollo a la medida',
  book_h4_text: 'Página Web',
  book_h4_sub: 'Diseño y desarrollo web',
  book_loading: 'Cargando calendario...',
  book_fallback: '¿Problemas para ver el calendario?',
  book_fallback_link: 'Ábrelo aquí',
  book_badge: 'Agenda disponible ahora',
  book_cta_heading: 'Cuéntanos qué necesita tu negocio',
  book_cta_desc: 'Ya sea una demo del sistema, consultoría tecnológica, un proyecto a la medida o tu primera página web — agenda tu cita y lo vemos juntos.',
  book_cta_btn: 'Agenda tu Cita Gratis',
  book_cta_note: 'Sin tarjeta de crédito · Sin compromiso · Respuesta inmediata',
  book_steps_title: '¿Cómo funciona el agendamiento?',
  book_step1_title: 'Abre el asistente IA',
  book_step1_desc: 'Haz clic en el botón y se abre el asistente de voz InnoFlex. Puedes hablar o escribir — él entiende ambos.',
  book_step2_title: 'Dile cuándo prefieres',
  book_step2_desc: 'El agente consulta la disponibilidad en tiempo real y bloquea el horario automáticamente. Sin formularios ni pasos extras.',
  book_step3_title: 'Confirmación automática',
  book_step3_desc: 'Recibirás un correo de confirmación al instante. El agente gestiona todo el proceso por ti.',
  book_agent_note_title: '4 tipos de sesión disponibles',
  book_agent_note_desc: 'Demo del sistema, consultoría, proyecto nuevo o creación de página web. Elige lo que mejor se adapte a lo que necesitas.',
  book_social_title: '+50 citas agendadas este mes',
  book_social_sub: 'Empresas de RD y Latinoamérica ya confían en InnoFlex',
  // Footer
  footer_desc: 'Software de facturación inteligente y soluciones tecnológicas a la medida que ayudan a los negocios a automatizarse, crecer y tener control total.',
  footer_contact_btn: 'Contáctanos',
  footer_rights: 'Todos los derechos reservados.',
  footer_cat_solutions: 'Soluciones',
  footer_cat_industries: 'Industrias',
  footer_cat_company: 'Empresa',
  footer_l_billing: 'Software de Facturación',
  footer_l_custom: 'Desarrollo a la Medida',
  footer_l_consulting: 'Consultoría Tecnológica',
  footer_l_restaurants: 'Restaurantes',
  footer_l_supermarkets: 'Supermercados',
  footer_l_hardware: 'Ferreterías',
  footer_l_distributors: 'Dealers',
  footer_l_industries_all: 'Ver todos los sectores',
  footer_l_why: '¿Por qué InnoFlex?',
  footer_l_testimonials: 'Testimonios',
  footer_l_pricing: 'Precios',
  footer_l_faq: 'Preguntas Frecuentes',
  footer_l_contact: 'Contacto',
  // Navbar blog
  nav_blog: 'Blog',
  // Footer blog
  footer_l_blog: 'Blog & Recursos',
  // WhatsApp Float
  whatsapp_online: 'En línea ahora',
  whatsapp_msg: '¡Hola! 👋 ¿Listo para automatizar tu negocio? Escríbenos ahora.',
  whatsapp_chat: 'Chatear ahora',
  // Contact select & placeholders
  contact_ind_restaurant: 'Restaurante',
  contact_ind_supermarket: 'Supermercado',
  contact_ind_hardware: 'Ferretería',
  contact_ind_minimarket: 'Minimarket / Colmado',
  contact_ind_distributor: 'Distribuidora / Dealer',
  contact_ind_loan: 'Agencia de Préstamos',
  contact_ind_other: 'Otro',
  contact_ph_name: 'Juan Pérez',
  contact_ph_phone: '+1 809 000 0000',
  contact_ph_email: 'tu@negocio.com',
  contact_ph_msg: 'Cuéntanos sobre tu negocio y lo que necesitas...',
  contact_form_request: 'Tipo de solicitud',
  contact_req_placeholder: 'Selecciona lo que necesitas...',
  contact_req_demo: 'Demo del Sistema',
  contact_req_consulting: 'Consultoría Tecnológica',
  contact_req_full_bundle: 'Paquete Completo con e-CF — $450',
  contact_req_fel_only: 'Solo Certificación e-CF — $300',
  contact_req_project: 'Proyecto a la Medida',
  contact_req_website: 'Página Web',
  contact_req_other: 'Otro',
  // Activation Process
  activation_label: 'Proceso de Activación',
  activation_title_1: 'Empieza',
  activation_title_2: 'desde 48h',
  activation_sub: 'Sin complicaciones. Tres pasos simples y tu negocio ya está automatizado.',
  activation_step_label: 'Paso',
  activation_step1_title: 'Elige tu Plan',
  activation_step1_desc: 'Selecciona el plan que mejor se adapte a tu negocio y tu presupuesto. Desde básico hasta premium, hay uno para cada etapa.',
  activation_step1_detail: 'Desde $29.99/mes',
  activation_step2_title: 'Cuéntanos de ti',
  activation_step2_desc: 'Llena el formulario con los datos de tu negocio. Un asesor te contactará en menos de 24 horas para coordinar todo.',
  activation_step2_detail: 'Respuesta en menos de 24h',
  activation_step3_title: 'Listo para usar',
  activation_step3_desc: 'Instalamos, configuramos y capacitamos a tu equipo. Tu sistema estará activo, probado y listo en un tiempo que depende del tipo de empresa.',
  activation_step3_detail: 'Activo desde 48h',
  activation_cta: 'Elegir mi Plan',
  activation_cta_note: 'Sin tarjeta de crédito · Implementación desde 48h',
  // BookingCalendar
  cal_step_date: 'Fecha',
  cal_step_time: 'Horario',
  cal_step_form: 'Confirmar',
  cal_prev: 'Mes anterior',
  cal_next: 'Mes siguiente',
  cal_no_slots: 'No hay horarios disponibles para este día.',
  cal_back_date: 'Volver a fechas',
  cal_modify_time: 'Cambiar horario',
  cal_your_booking: 'Tu reserva',
  cal_date_label: 'Fecha',
  cal_time_label: 'Hora',
  cal_name_label: 'Nombre completo',
  cal_phone_label: 'Teléfono',
  cal_name_placeholder: 'Tu nombre completo',
  cal_phone_placeholder: '+1 (809) 000-0000',
  cal_submit: 'Confirmar Cita',
  cal_submitting: 'Confirmando...',
  cal_success_title: '¡Cita agendada con éxito!',
  cal_success_msg: 'Recibirás un correo de confirmación muy pronto. ¡Nos vemos!',
  cal_error: 'No se pudo confirmar la cita. Por favor intenta de nuevo o escríbenos por WhatsApp.',
  cal_loading: 'Cargando disponibilidad...',
  cal_wd_sun: 'Dom',
  cal_wd_mon: 'Lun',
  cal_wd_tue: 'Mar',
  cal_wd_wed: 'Mié',
  cal_wd_thu: 'Jue',
  cal_wd_fri: 'Vie',
  cal_wd_sat: 'Sáb',
  cal_m1: 'Enero',
  cal_m2: 'Febrero',
  cal_m3: 'Marzo',
  cal_m4: 'Abril',
  cal_m5: 'Mayo',
  cal_m6: 'Junio',
  cal_m7: 'Julio',
  cal_m8: 'Agosto',
  cal_m9: 'Septiembre',
  cal_m10: 'Octubre',
  cal_m11: 'Noviembre',
  cal_m12: 'Diciembre',
  // BookingCalendar additions
  cal_biz_label: 'Tipo de negocio',
  cal_biz_placeholder: 'Selecciona tu industria...',
  cal_biz_restaurant: 'Restaurante / Food & Beverage',
  cal_biz_supermarket: 'Supermercado / Colmado',
  cal_biz_hardware: 'Ferretería',
  cal_biz_minimarket: 'Minimarket',
  cal_biz_distributor: 'Distribuidora',
  cal_biz_loan: 'Agencia de Préstamos',
  cal_biz_events: 'Eventos / Entretenimiento',
  cal_biz_tech: 'Tecnología',
  cal_biz_other: 'Otro',
  cal_legend_available: 'Disponible',
  cal_legend_selected: 'Seleccionado',
  cal_email_label: 'Correo electrónico',
  cal_email_placeholder: 'tu@correo.com',
  // Nuevas claves del sistema de reservas
  cal_slot_duration: '1 hora · Sesión personalizada',
  cal_session_limit: 'Ya tienes una cita agendada en esta sesión. Si necesitas modificar tu reserva, contáctanos por WhatsApp.',
  cal_success_email_msg: 'Hemos enviado una confirmación a {email}. ¡Nos vemos pronto!',
  cal_confirm_title: 'Resumen de tu Cita',
  cal_confirm_date: 'Fecha',
  cal_confirm_time: 'Horario',
  cal_confirm_name: 'Nombre',
  cal_confirm_phone: 'Teléfono',
  cal_confirm_email: 'Correo',
  cal_confirm_biz: 'Tipo de negocio',
  cal_confirm_note: 'Revisa tu correo (incluyendo la carpeta de spam). Si no recibes la confirmación en los próximos minutos, escríbenos por WhatsApp.',
  cal_confirm_new: 'Agendar otra cita',
  // Demo modalidad
  cal_demo_mode_label: 'Modalidad de la cita',
  cal_demo_mode_remote: 'Remoto · Videollamada',
  cal_demo_mode_in_person: 'Presencial · Visita',
  cal_confirm_mode: 'Modalidad',
  // Contador de urgencia
  cal_slots_week_few: '¡Solo quedan {n} horarios esta semana!',
  cal_slots_week_some: 'Quedan {n} horarios disponibles esta semana',
  cal_slots_week_many: '{n} horarios disponibles esta semana',
  cal_urgency_last: '¡Último horario disponible para este día!',
  cal_urgency_few: '¡Solo quedan {n} horarios disponibles hoy!',
  cal_wa_notify_btn: 'Enviar datos al equipo por WhatsApp',
  cal_phone_is_whatsapp: 'Este número es de WhatsApp',
  // Tipo de cita
  cal_appt_type_label: 'Tipo de cita',
  cal_appt_type_placeholder: 'Selecciona el tipo...',
  cal_appt_demo: 'Demo del Sistema',
  cal_appt_consultoria: 'Consultoría',
  cal_appt_proyecto: 'Proyecto Nuevo',
  cal_appt_web: 'Creación de Página Web',
  cal_appt_otro: 'Otro',
  cal_confirm_appt_type: 'Tipo de cita',
  cal_appt_otro_placeholder: 'Describe brevemente qué necesitas o qué tipo de servicio buscas...',
  // Partners
  partners_label: 'Alianzas Estratégicas',
  partners_title_1: 'Nuestros',
  partners_title_accent: 'Partners Oficiales',
  partners_sub: 'Trabajamos de la mano con los mejores proveedores para ofrecerte un ecosistema tecnológico completo e integrado.',
  partners_fel_name: 'República FEL',
  partners_fel_category: 'Partner Oficial · Facturación Electrónica',
  partners_fel_tagline: 'Proveedor certificado de Factura Electrónica para República Dominicana',
  partners_fel_desc: 'RepublicaFEL es nuestro partner oficial de facturación electrónica. Su plataforma e-CF certificada ante la DGII se integra nativamente con InnoFlex, permitiéndote emitir facturas, notas de crédito y todos los comprobantes fiscales desde un solo sistema.',
  partners_fel_tag1: 'e-CF Certificado DGII',
  partners_fel_tag2: 'Portal e-CF Dedicado',
  partners_fel_tag3: 'Integración Nativa',
  partners_fel_tag4: 'Soporte Local RD',
  partners_fel_cta: 'Conocer RepublicaFEL',
  partners_portal_btn: 'Acceder al Portal',
  partners_portal_desc: 'Consulta tus e-CF, gestiona NCF y haz seguimiento fiscal directamente desde el portal oficial.',
  // FEL Comparison
  fel_comp_title: 'InnoFlex vs. Contratar Directo',
  fel_comp_sub: 'Con InnoFlex, el mismo precio que solo el e-CF te da el sistema completo',
  fel_comp_col1: 'e-CF Directo',
  fel_comp_col1_sub: 'Solo con RepublicaFEL',
  fel_comp_col2: 'e-CF vía InnoFlex',
  fel_comp_col2_sub: 'Certificación + soporte',
  fel_comp_col3: 'Paquete Completo',
  fel_comp_col3_sub: 'Sistema + e-CF + portal',
  fel_comp_best: 'Mejor Valor',
  fel_comp_save_150: 'Ahorras $150',
  fel_comp_save_200: 'Ahorras $200',
  fel_comp_note: 'vs. implementación + e-CF directo = $650',
  fel_comp_f1: 'Certificación e-CF DGII',
  fel_comp_f2: 'Portal RepublicaFEL',
  fel_comp_f3: 'Soporte de activación',
  fel_comp_f4: 'Sistema ERP · POS · Contabilidad',
  fel_comp_f5: 'Implementación incluida',
  fel_comp_f6: 'Capacitación del equipo',
  fel_comp_total: 'Precio total',
  fel_comp_cta2: 'Solo quiero el e-CF',
  fel_comp_cta3: 'Quiero el Paquete',
  // FEL certification routes (price clarity)
  fel_routes_label: 'Certificación e-CF',
  fel_routes_title: 'El mismo trámite, mejor precio con nosotros',
  fel_routes_sub: 'Así queda tu certificación de facturación electrónica según cómo la hagas.',
  fel_route1_title: 'Directo con RepublicaFEL',
  fel_route1_sub: 'Fuera de InnoFlex',
  fel_route1_note: 'Gestionas la certificación por tu cuenta directamente con RepublicaFEL.',
  fel_route2_title: 'Solo e-CF, vía InnoFlex',
  fel_route2_sub: 'Certificación + soporte',
  fel_route2_note: 'Nosotros activamos y configuramos tu e-CF ante la DGII. Ahorras $150 vs. hacerlo directo.',
  fel_route3_title: 'Sistema InnoFlex + e-CF',
  fel_route3_sub: 'Paquete completo',
  fel_route3_price_sub: 'e-CF $250 + implementación $200',
  fel_route3_note: 'Con el sistema de InnoFlex, la e-CF baja a $250 y sumas $200 de implementación. Por lo mismo que cuesta certificar directo ($450) te llevas también el sistema completo.',
  partners_bundle_label: 'Paquete InnoFlex + RepublicaFEL',
  partners_bundle_desc: 'Sistema de gestión completo + certificación e-CF ($250 en bundle, vs $300 standalone) + portal RepublicaFEL. Ahorras $200 vs. contratar todo por separado.',
  partners_bundle_price: '$450',
  partners_bundle_note: 'Único pago · Más el plan mensual que elijas',
  partners_bundle_cta: 'Quiero el Paquete Completo',
  partners_addon_impl: 'Implementación',
  partners_addon_impl_price: '$200',
  partners_addon_impl_note: 'Único pago · Incluido en el paquete',
  partners_addon_fel: 'Certificación e-CF',
  partners_addon_fel_price: '$300',
  partners_addon_fel_note: 'Único pago · $150 menos que contratar directo',
  // Pricing FEL Addons
  pricing_addons_title: 'Servicios de Implementación',
  pricing_addons_sub: 'Pagos únicos que se suman a tu plan mensual. Elige lo que necesitas.',
  pricing_addon1_title: 'Implementación Estándar',
  pricing_addon1_desc: 'Instalación, configuración del sistema y capacitación inicial de tu equipo.',
  pricing_addon1_price: '$200',
  pricing_addon1_badge: 'Requerido',
  pricing_addon2_title: 'Certificación e-CF',
  pricing_addon2_desc: 'Facturación electrónica e-CF certificada via InnoFlex + RepublicaFEL. Ahorras $150 vs. contratar directo con RepublicaFEL ($450).',
  pricing_addon2_price: '$300',
  pricing_addon2_badge: 'Opcional',
  pricing_addon3_title: 'Paquete Completo',
  pricing_addon3_desc: 'Implementación ($200) + Certificación e-CF ($250) + Portal RepublicaFEL. La e-CF baja de $300 a $250 dentro del bundle.',
  pricing_addon3_price: '$450',
  pricing_addon3_badge: 'Mejor Valor',
  pricing_addon3_savings: 'Ahorras $200 vs. impl + e-CF directo ($650)',
  pricing_addons_note: 'Todos los pagos de implementación son únicos. La mensualidad del plan se cobra por separado.',

  // ── Servicios adicionales (tabs) ──────────────────────────────
  addsvc_label: 'Escala a tu ritmo',
  addsvc_title: 'Servicios adicionales',
  addsvc_intro: 'Activa módulos, usuarios o servicios adicionales según el crecimiento de tu negocio.',
  addsvc_note: 'Los consumos variables de IA, WhatsApp, SMS, almacenamiento masivo, APIs, certificaciones, proveedores externos o integraciones especiales se cotizan por separado.',
  addsvc_cat1: 'Usuarios y operación',
  addsvc_cat2: 'Módulos por industria',
  addsvc_cat3: 'Automatización e integraciones',
  addsvc_cat4: 'Soporte, capacitación y migración',
  // Tab 1 — Usuarios y operación
  addsvc_a1_n: 'Usuario administrativo adicional',
  addsvc_a1_p: 'US$5.99/mes',
  addsvc_a1_d: 'Para usuarios de oficina, contabilidad, supervisor o gerencia.',
  addsvc_a2_n: 'Usuario caja/POS adicional',
  addsvc_a2_p: 'US$8.99/mes',
  addsvc_a2_d: 'Para puestos de venta con permisos de facturación/cobro.',
  addsvc_a3_n: 'Caja adicional',
  addsvc_a3_p: 'US$10.99/mes',
  addsvc_a3_d: 'Aplica cuando se agrega un punto de cobro físico o virtual.',
  addsvc_a4_n: 'Sucursal adicional',
  addsvc_a4_p: 'US$29.99/mes',
  addsvc_a4_d: 'Incluye separación de ventas, inventario, reportes y permisos por sucursal.',
  // Tab 2 — Módulos por industria
  addsvc_b1_n: 'Módulo e-CF / Facturación electrónica',
  addsvc_b1_p: 'Desde US$19.99/mes',
  addsvc_b1_d: 'No incluye costos de certificación, firma digital, proveedor o partner fiscal.',
  addsvc_b2_n: 'Certificación / implementación e-CF',
  addsvc_b2_p: 'US$250 pago único',
  addsvc_b2_d: 'Según complejidad, documentos, pruebas y acompañamiento requerido.',
  addsvc_b3_n: 'Módulo restaurante',
  addsvc_b3_p: 'US$29.99/mes',
  addsvc_b3_d: 'Mesas, comandas, cocina, recetas, productos terminados y combos.',
  addsvc_b4_n: 'Módulo distribución / rutas',
  addsvc_b4_p: 'US$49.99/mes',
  addsvc_b4_d: 'Rutas, vendedores, sectores, metas, visitas e inventario por vehículo.',
  addsvc_b5_n: 'Módulo rent car',
  addsvc_b5_p: 'US$29.99/mes',
  addsvc_b5_d: 'Reservas, contratos, flota, depósitos, inspecciones y daños.',
  addsvc_b6_n: 'Módulo condominios',
  addsvc_b6_p: 'US$9.99/mes',
  addsvc_b6_d: 'Cuotas recurrentes, moras, contratos, residentes y documentos.',
  addsvc_b7_n: 'Módulo odontología / salud',
  addsvc_b7_p: 'US$79.99/mes',
  addsvc_b7_d: 'Agenda, expediente, tratamientos, cobros e inventario clínico.',
  addsvc_b8_n: 'Módulo construcción',
  addsvc_b8_p: 'US$99.99/mes',
  addsvc_b8_d: 'Obras, cubicaciones, compras, materiales y rentabilidad por proyecto.',
  // Tab 3 — Automatización e integraciones
  addsvc_c1_n: 'Mensajes WhatsApp / campañas',
  addsvc_c1_p: 'US$19.99/mes + consumo',
  addsvc_c1_d: 'Mensajes masivos, segmentación y plantillas. Costos de API/WhatsApp aparte.',
  addsvc_c2_n: 'Chatbot IA',
  addsvc_c2_p: 'Desde US$29.99/mes + consumo',
  addsvc_c2_d: 'Consultas, respuestas automáticas, asistente de ventas o soporte.',
  addsvc_c3_n: 'API / integraciones',
  addsvc_c3_p: 'Desde US$49.99 pago único',
  addsvc_c3_d: 'Webhooks, integraciones externas y acceso técnico controlado. Depende de la complejidad.',
  // Tab 4 — Soporte, capacitación y migración
  addsvc_d1_n: 'Soporte 24/7 crítico',
  addsvc_d1_p: 'Desde US$49.99/mes',
  addsvc_d1_d: 'Incidencias críticas fuera de horario. Incluido parcialmente en Premium/Personalizado.',
  addsvc_d2_n: 'Capacitación adicional',
  addsvc_d2_p: 'US$50/hora o US$150/sesión',
  addsvc_d2_d: 'Entrenamiento adicional para personal nuevo o cambios de proceso.',
  addsvc_d3_n: 'Migración de datos',
  addsvc_d3_p: 'US$100 - US$800 pago único',
  addsvc_d3_d: 'Productos, clientes, inventario y facturas históricas. Depende de la calidad del archivo.',
  addsvc_d4_n: 'Desarrollo personalizado',
  addsvc_d4_p: 'US$45 - US$75/hora',
  addsvc_d4_d: 'Cambios fuera del alcance, integraciones especiales y reglas complejas.',

  // ── Soporte (bloque en cada tarjeta de plan) ──────────────────
  support_block_title: 'Soporte',
  support_row_channels: 'Canales',
  support_row_response: 'Respuesta',
  support_row_includes: 'Incluye',
  support_starter_channels: 'WhatsApp o correo · canal dedicado de tu empresa',
  support_starter_response: '24–48 h hábiles',
  support_starter_includes: 'Base de conocimiento y soporte remoto básico',
  support_business_channels: 'WhatsApp prioritario · canal dedicado de tu empresa',
  support_business_response: '12–24 h hábiles desde la solicitud',
  support_business_includes: 'Soporte remoto y 1 sesión de entrenamiento inicial',
  support_pro_channels: 'WhatsApp, llamada y remoto · canal dedicado',
  support_pro_response: '4–8 h hábiles · 24/7 en emergencias',
  support_pro_includes: 'Soporte prioritario, 2 sesiones y revisión de configuración',
  support_premium_channels: 'Línea directa: WhatsApp, llamada, remoto y canal asignado',
  support_premium_response: '2–4 h en crítico · 24/7 en emergencias',
  support_premium_includes: 'Acompañamiento cercano, revisiones operativas y soporte a gerencia',
  support_custom_channels: 'Canal dedicado',
  support_custom_response: '1–2 h en crítico según contrato',
  support_custom_includes: 'Account manager, reuniones, monitoreo y capacitación recurrente',
  // Services Software Section (ERP/POS/Contabilidad)
  sw_label: 'Sistema de Gestión',
  sw_title_1: 'ERP · POS ·',
  sw_title_accent: 'Contabilidad',
  sw_title_2: 'todo en uno',
  sw_cycle_2: 'para tu negocio',
  sw_cycle_3: 'siempre disponible',
  sw_sub: 'Un sistema completo que reemplaza hojas de cálculo, cajas manuales y registros en papel. Opera tu negocio entero desde una sola plataforma.',
  sw_keyword_erp: 'ERP',
  sw_keyword_pos: 'POS',
  sw_keyword_conta: 'Contabilidad',
  sw_keyword_inv: 'Inventario',
  sw_keyword_fel: 'Facturación e-CF',
  sw_keyword_multi: 'Multi-Sucursal',
  sw_keyword_offline: 'Sin Internet',
  sw_mod_pos_title: 'Punto de Venta (POS)',
  sw_mod_pos_sub: 'Cobra rápido, preciso y sin errores',
  sw_mod_pos_f1: 'Múltiples cajas registradoras',
  sw_mod_pos_f2: 'Turnos y control de empleados',
  sw_mod_pos_f3: 'Cierre de caja automático',
  sw_mod_pos_f4: 'Funciona sin internet',
  sw_mod_erp_title: 'ERP — Gestión Empresarial',
  sw_mod_erp_sub: 'El cerebro de tu operación completa',
  sw_mod_erp_f1: 'Compras y control de proveedores',
  sw_mod_erp_f2: 'Inventario en tiempo real',
  sw_mod_erp_f3: 'Reportes financieros avanzados',
  sw_mod_erp_f4: 'Gestión multi-sucursal',
  sw_mod_conta_title: 'Contabilidad & Finanzas',
  sw_mod_conta_sub: 'Tus números siempre claros y al día',
  sw_mod_conta_f1: 'P&G automático sin contadores',
  sw_mod_conta_f2: 'Flujo de caja en tiempo real',
  sw_mod_conta_f3: 'Control de gastos y ganancias',
  sw_mod_conta_f4: 'Acceso desde celular o PC',
  sw_mod_fel_title: 'Facturación Electrónica e-CF',
  sw_mod_fel_sub: 'Certificado DGII · Portal RepublicaFEL',
  sw_mod_fel_f1: 'e-CF generados por cada venta',
  sw_mod_fel_f2: 'Notas de crédito y débito',
  sw_mod_fel_f3: 'Portal RepublicaFEL integrado',
  sw_mod_fel_f4: 'Certificación via InnoFlex — ahorras $150',
  sw_cta_heading: '¿Listo para digitalizar tu negocio?',
  sw_cta_desc: 'ERP, POS y Contabilidad configurados y listos desde 48h (según el tipo de empresa). Nuestro equipo maneja toda la instalación por ti.',
  sw_cta_plans: 'Ver Planes y Precios',
  sw_cta_ask: 'Hablar con un Asesor',
  sw_cta_book: 'Agenda tu Cita Gratis',
  // Digital Services Section
  digital_label: 'Servicios Digitales',
  digital_title_1: 'Apps, Webs &',
  digital_title_accent: 'Desarrollo a la Medida',
  digital_sub: 'Más allá del sistema de gestión — diseñamos y desarrollamos cualquier solución digital que tu negocio necesite.',
  digital_p1_title: 'Apps Móviles',
  digital_p1_sub: 'Aplicaciones iOS y Android diseñadas desde cero para tu negocio',
  digital_p1_f1: 'Diseño UX/UI moderno y personalizado',
  digital_p1_f2: 'Integración con APIs y sistemas existentes',
  digital_p1_f3: 'Publicación en App Store & Google Play',
  digital_p1_f4: 'Backend escalable, seguro y en la nube',
  digital_p1_for: 'Tecnologías:',
  digital_p1_tag1: 'iOS & Android',
  digital_p1_tag2: 'React Native',
  digital_p1_tag3: 'Flutter',
  digital_p2_title: 'Páginas Web',
  digital_p2_sub: 'Presencia digital profesional que convierte visitas en clientes reales',
  digital_p2_f1: 'Diseño responsivo y moderno a la medida',
  digital_p2_f2: 'Landing pages, corporativos y e-commerce',
  digital_p2_f3: 'SEO técnico optimizado desde el inicio',
  digital_p2_f4: 'Velocidad, hosting y dominio gestionados',
  digital_p2_for: 'Tipos:',
  digital_p2_tag1: 'Landing Pages',
  digital_p2_tag2: 'E-commerce',
  digital_p2_tag3: 'Portafolios',
  digital_p3_title: 'Diseño & Software',
  digital_p3_sub: 'Sistemas internos, plataformas y software a la medida para cualquier industria',
  digital_p3_f1: 'Sistemas internos y paneles de control',
  digital_p3_f2: 'Integraciones con APIs externas',
  digital_p3_f3: 'Automatizaciones y flujos de trabajo',
  digital_p3_f4: 'Diseño UI/UX profesional',
  digital_p3_for: 'Para:',
  digital_p3_tag1: 'Startups',
  digital_p3_tag2: 'PYMEs',
  digital_p3_tag3: 'Empresas',
  digital_p4_title: 'Consultoría',
  digital_p4_sub: 'Estrategia tecnológica para digitalizar y escalar tu negocio',
  digital_p4_f1: 'Diagnóstico completo de procesos y sistemas',
  digital_p4_f2: 'Plan de digitalización personalizado',
  digital_p4_f3: 'Selección e integración de herramientas',
  digital_p4_f4: 'Acompañamiento y seguimiento post-proyecto',
  digital_p4_for: 'Para:',
  digital_p4_tag1: 'Startups',
  digital_p4_tag2: 'PYMEs',
  digital_p4_tag3: 'Empresas',
  digital_cta_heading: 'Cuéntanos tu idea y la hacemos realidad',
  digital_cta_desc: 'Apps, páginas web, software personalizado o consultoría estratégica — trabajamos contigo desde el concepto hasta el lanzamiento.',
  digital_cta_ask: 'Hablar con un Asesor',
  digital_cta_book: 'Agenda tu Cita Gratis',
  // ── Plan limits pills ──────────────────────────────────────────
  plan_starter_l1: '1 Usuario',
  plan_starter_l2: '1 Caja POS',
  plan_starter_l3: '1 Sucursal',
  plan_starter_l4: '1 Almacén',
  plan_starter_l5: 'Soporte estándar',

  plan_business_l1: '3 Usuarios',
  plan_business_l2: '2 Cajas POS',
  plan_business_l3: '1 Sucursal',
  plan_business_l4: '1 Almacén',
  plan_business_l5: 'Soporte WhatsApp',

  plan_pro_l1: '5 Usuarios',
  plan_pro_l2: '4 Cajas POS',
  plan_pro_l3: '2 Sucursales',
  plan_pro_l4: '2 Almacenes',
  plan_pro_l5: 'Soporte prioritario',

  plan_premium_l1: '9 Usuarios',
  plan_premium_l2: '6 Cajas POS',
  plan_premium_l3: '3 Sucursales',
  plan_premium_l4: '3 Almacenes',
  plan_premium_l5: 'Soporte 24/7',

  plan_custom_l1: 'Usuarios a medida',
  plan_custom_l2: 'Cajas a medida',
  plan_custom_l3: 'Sucursales a medida',
  plan_custom_l4: 'Almacenes a medida',
  plan_custom_l5: 'SLA acordado',

  plan_custom_tagline: 'Para cadenas, clínicas, distribuidoras, supermercados, grupos gastronómicos y empresas con procesos personalizados.',
  plan_custom_cta: 'Solicitar cotización',
  plan_custom_price: 'Cotizar',
  pricing_badge_custom: 'A la Medida',

  // ── InnoFlex Dealers ──────────────────────────────────────────
  dealers_label: 'InnoFlex Dealers',
  dealers_title_1: '¿Eres un',
  dealers_title_accent: 'dealer?',
  dealers_sub: 'Un sistema hecho para dealers y auto imports: inventario de vehículos, ventas, financiamiento y facturación — todo en un solo lugar.',
  // Live system demo (dealers)
  dealers_demo_label: 'Demo en vivo',
  dealers_demo_title: 'Prueba el sistema como dealer',
  dealers_demo_desc: 'Entra al sistema real con una cuenta de demostración y explora todo antes de decidir.',
  dealers_demo_user_label: 'Usuario',
  dealers_demo_pass_label: 'Contraseña',
  dealers_demo_cta: 'Probar el sistema',
  dealers_recommended: 'Recomendado para dealers en crecimiento',
  dealers_whats_included: '¿Qué incluye?',
  dealers_hide_included: 'Ocultar detalles',
  dealers_compare_show: 'Comparar planes',
  dealers_compare_hide: 'Ocultar comparación',
  dealers_impl: 'Implementación US$200 · pago único (sistema de facturación)',
  dealers_fel_addon: '+US$10/mes: facturación electrónica (e-CF)',
  dealers_cert: 'Certificación e-CF US$250 · pago único, solo si aún no estás certificado',
  dealers_save_badge: 'Ahorras $9.99/mes',
  dealers_annual_note: 'facturado anual · ahorras $47.88/año',
  dealers_cta: 'Empezar ahora',
  dealers_cta_custom: 'Solicitar cotización',
  dealers_costs_title: 'Costos del sistema de facturación',
  // Taglines
  dplan_starter_tag: 'Para dealers que empiezan a ordenar ventas e inventario.',
  dplan_business_tag: 'Para dealers con más volumen, compras y financiamiento.',
  dplan_pro_tag: 'Control avanzado de inventario, contabilidad y reportes.',
  dplan_premium_tag: 'Para dealers con varios lotes, integraciones con IA y bot de WhatsApp.',
  dplan_custom_tag: 'Para cadenas de dealers y operaciones a la medida.',
  // Features
  df_billing_pos: 'Facturación y punto de venta',
  df_vehicle_inv_basic: 'Inventario de vehículos (VIN, chasis, matrícula)',
  df_clients_buyers: 'Clientes y compradores',
  df_offline: 'Modo offline — vende sin internet',
  df_reports_basic: 'Reportes básicos de ventas',
  df_includes_starter: 'Todo lo del plan Starter',
  df_purchases: 'Compras e importadores',
  df_receivables: 'Cuentas por cobrar',
  df_stock_alerts: 'Alertas de inventario',
  df_accounting: 'Contabilidad operativa',
  df_includes_business: 'Todo lo del plan Business',
  df_financing: 'Financiamiento de vehículos (cuotas y planes de pago)',
  df_smart_alerts: 'Alertas inteligentes',
  df_priority_support: 'Soporte prioritario',
  df_includes_pro: 'Todo lo del plan Pro',
  df_clients_dashboard: 'Dashboard avanzado de clientes',
  df_accounting_adv: 'Contabilidad avanzada',
  df_purchase_orders: 'Órdenes de compra y listas de precios',
  df_vehicle_costs: 'Dashboard de gastos por vehículo (piezas, grúas, muelle…)',
  df_whatsapp_ai: 'Bot de WhatsApp con IA',
  df_includes_premium: 'Todo lo del plan Premium',
  df_integrations: 'Integraciones a la medida',
  df_api: 'API para dealers',
  df_ai_usage: 'IA por consumo',
  df_sla: 'SLA y ejecutivo de cuenta',
  // Comparison
  dcmp_title: 'Comparativa de planes',
  dcmp_feature: 'Función',
  dcmp_vehicle_inv: 'Inventario de vehículos',
  dcmp_offline: 'Modo offline',
  dcmp_receivables: 'Cuentas por cobrar',
  dcmp_accounting: 'Contabilidad',
  dcmp_financing: 'Financiamiento',
  dcmp_support_priority: 'Soporte prioritario',
  dcmp_clients_dashboard: 'Dashboard de clientes',
  dcmp_purchase_orders: 'Órdenes de compra / precios',
  dcmp_vehicle_costs: 'Gastos por vehículo',
  dcmp_whatsapp_ai: 'Bot WhatsApp con IA',
  dcmp_api: 'API e integraciones',

  // ── Notas visibles debajo de los planes ───────────────────────
  pricing_note_usd: 'Precios publicados en USD.',
  pricing_note_dop: 'Los precios pueden ser cobrados en DOP a la tasa del día.',
  pricing_note_impl: 'La implementación se paga una sola vez.',
  pricing_note_extras: 'Facturación electrónica, certificación, firma digital, proveedor/partner fiscal, IA, WhatsApp, SMS, almacenamiento masivo, API o integraciones pueden tener costos adicionales según el caso.',

  // ── Notas comerciales importantes (pie de la sección de precios) ─
  pricing_notes_title: 'Notas importantes',
  pricing_imp_note_usd: 'Los precios están expresados en dólares estadounidenses (USD).',
  pricing_imp_note_dop: 'Los pagos pueden realizarse en pesos dominicanos (DOP) a la tasa vigente del día.',
  pricing_imp_note_impl: 'La implementación se paga una sola vez y varía según el plan o alcance.',
  pricing_imp_note_extras: 'Los módulos adicionales, integraciones, consumo de IA, WhatsApp, SMS, almacenamiento masivo, API, certificaciones, firma digital, proveedores externos o servicios personalizados pueden tener costos adicionales.',
  pricing_imp_note_fel: 'La facturación electrónica puede requerir certificación, configuración, firma digital y/o servicios de terceros.',
  pricing_imp_note_custom: 'El desarrollo personalizado no está incluido dentro de los planes mensuales estándar.',
  pricing_imp_note_evolution: 'Los planes pueden cambiar según evolución del producto, alcance y necesidades del cliente.',

  // ── Compare table – secciones ─────────────────────────────────
  compare_group_limits: 'Límites del Plan',
  compare_group_features: 'Funcionalidades',
  compare_lim_users: 'Usuarios',
  compare_lim_cajas: 'Cajas POS',
  compare_lim_warehouses: 'Almacenes',
  compare_lim_branches: 'Sucursales',
  compare_lim_support: 'Tipo de soporte',

  // ── Rediseño de planes: badges, comparativa simple y enterprise ─
  pricing_badge_complete: 'Más completo',
  pricing_badge_enterprise: 'Enterprise',
  pricing_recommended: 'Recomendado para negocios en crecimiento',
  compare_simple_title: 'Comparativa rápida de planes',
  compare_addon_label: 'Add-on',
  compare_legend_included: 'Incluido',
  compare_legend_addon: 'Costo adicional (add-on)',
  compare_legend_no: 'No incluido',
  crow_inventory_adv: 'Inventario avanzado',
  crow_accounting: 'Contabilidad operativa',
  crow_offline: 'Modo offline',
  crow_bulk_msg: 'Mensajes masivos',
  crow_ai: 'IA / Chatbot',
  crow_support_priority: 'Soporte prioritario',
  crow_support_critical: 'Soporte crítico 24/7',
  crow_integrations_api: 'Integraciones / API',
  crow_custom_dev: 'Desarrollo personalizado',
  plan_custom_ideal: 'Ideal para',
  custom_chip_1: 'Cadenas',
  custom_chip_2: 'Clínicas',
  custom_chip_3: 'Distribuidoras',
  custom_chip_4: 'Supermercados',
  custom_chip_5: 'Grupos gastronómicos',
  custom_chip_6: 'Multi-sucursal',

  // ── Sección Enterprise (plan Personalizado destacado) ─────────
  ent_badge: 'Enterprise',
  ent_title: '¿Tienes una operación más grande?',
  ent_sub: 'Creamos una solución personalizada para cadenas, clínicas, supermercados, grupos gastronómicos, distribuidoras, rent cars, constructoras, condominios, dealers y negocios multi-sucursal.',
  ent_price_label: 'Precio',
  ent_price_value: 'Cotizar',
  ent_impl: 'Implementación desde',
  ent_impl_value: 'US$1,500',
  ent_spec_sla_l: 'SLA',
  ent_spec_sla_v: 'Según alcance',
  ent_spec_channel_l: 'Canal dedicado',
  ent_spec_channel_v: 'Disponible',
  ent_spec_integrations_l: 'Integraciones',
  ent_spec_integrations_v: 'Disponibles',
  ent_spec_dev_l: 'Desarrollo personalizado',
  ent_spec_dev_v: 'Cotizado por separado',
  ent_checklist_title: 'Para tu cotización, ten a mano:',
  ent_check_1: 'Número de sucursales',
  ent_check_2: 'Número de cajas',
  ent_check_3: 'Número de usuarios',
  ent_check_4: 'Número de almacenes',
  ent_check_5: 'Volumen mensual de facturas / ventas',
  ent_check_6: 'Módulos requeridos por industria',
  ent_check_7: 'Si requieres e-CF, contabilidad completa, API, WhatsApp o IA',
  ent_check_8: 'Cantidad de datos a migrar',
  ent_check_9: 'Nivel de soporte y SLA requerido',
  ent_check_10: 'Hardware: impresoras, balanzas, lectores, KDS, pantallas o tablets',
  ent_check_11: 'Integraciones con bancos, pagos, e-commerce, delivery, GPS o sistemas externos',
  ent_cta: 'Solicitar propuesta personalizada',
};

export default translations;
